























































































































































































































































































import { personnel } from "../../api/personnel/personnel";
import { shifts } from "../../api/shifts/shifts";
import { Component, Vue, Prop } from "vue-property-decorator";
import { aiaPersonnel } from "../../api/personnel/aiaPersonnel";
import Moment from "moment";
@Component({ name: "AddShift" })
export default class AddShift extends Vue {
  public personnelList: any[] = [];
  public types: any[] = [];
  public type: any = "";
  public date: any = "";
  public loading: boolean = false;
  public availableForemen: any[] = [];
  public availablePersonnel: any[] = [];
  public foremen: any[] = [];
  public workers: any[] = [];
  public foreman: any = "";
  public selectedPersonnel: any[] = [];
  public techs: any[] = [];
  public selectedTech: any = "";
  public standbyTechs: any[] = [];
  public selectedStandbyTech: any = "";
  public row: any = "";
  public senTechList: any[] = [];
  public senTechs: any[] = [];
  public availableSenTechs: any[] = [];
  public senTech: any = "";

  public techUpdate(id: any, index: number) {
    if (id == "") {
      this.techs.splice(index, 1);
      
    }
    console.log(this.techs);
  }
  public pushPersonnel() {
    this.techs.push({
      id:
        this.personnelList.find(r => r.id == this.selectedTech).firstname +
        " " +
        this.personnelList.find(r => r.id == this.selectedTech).lastname,
      value: this.selectedTech,
      start: this.types.find(r => r.value == this.type).start,
      end: this.types.find(r => r.value == this.type).end
    });
    this.selectedTech = "";
    this.availableForemen = [];
    this.availablePersonnel = [];
    console.log(this.techs);
  }
  public foremanMethod(query: string) {
    if (query != "" && query != undefined) {
      this.loading = true;
      this.loading = false;
      this.availableForemen = this.foremen.filter(item => {
        return (
          (item.label.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
            item.team == query) &&
          this.foreman != item.value &&
          this.techs.find(r => r.value == item.value) == undefined &&
          this.standbyTechs.find(r => r.value == item.value) == undefined
        );
      });
      this.availableForemen = this.availableForemen.concat(
        this.workers.filter(item => {
          return (
            (item.label.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              item.team == query) &&
            this.foreman != item.value &&
            this.techs.find(r => r.value == item.value) == undefined &&
            this.standbyTechs.find(r => r.value == item.value) == undefined
          );
        })
      );
      console.log(this.availableForemen);
    } else {
      this.availableForemen = [];
    }
  }
  public senTechMethod(query: string) {
    if (query != "" && query != undefined) {
      this.loading = true;
      this.loading = false;
      this.availableSenTechs = this.senTechs.filter(item => {
        return (
          item.label.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
          item.team == query
        );
      });
      console.log(this.availableForemen);
    } else {
      this.availableSenTechs = [];
    }
  }
  public techMethod(query: string) {
    if (query != "") {
      this.loading = true;
      this.loading = false;
      this.availablePersonnel = this.workers.filter(item => {
        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
      });
      console.log(this.availablePersonnel);
    } else {
      this.availablePersonnel = [];
    }
  }
  public endTimeChange(index: number) {
    if (this.techs[index].end.length === 2) {
      this.techs[index].end = this.techs[index].end + ":";
    }
  }
  public startTimeChange(index: number) {
    if (this.techs[index].start.length === 2) {
      this.techs[index].start = this.techs[index].start + ":";
    }
  }
  public async getPersonnelList() {
    await personnel
      .getAllPersonnel(
        this.$store.getters.getToken,
        this.$store.getters.getHost
      )
      .then(response => {
        response.json().then(resp => {
          this.personnelList = JSON.parse(JSON.stringify(resp));
          for (const p of this.personnelList) {
            if (this.$store.getters.getUserLevel < 1 || p.active) {
              if (p.wo_specialty == 1) {
                this.foremen.push({
                  label:
                    p.firstname +
                    " " +
                    p.lastname +
                    (!p.active ? " (INACTIVE)" : ""),
                  value: p.id,
                  team: p.team
                });
              } else {
                this.workers.push({
                  label:
                    p.firstname +
                    " " +
                    p.lastname +
                    (!p.active ? " (INACTIVE)" : ""),
                  value: p.id,
                  team: p.team
                });
              }
            }
          }
        });
      });
  }

  public async getSenTechList() {
    await aiaPersonnel
      .getAllPersonnel(
        this.$store.getters.getToken,
        this.$store.getters.getHost
      )
      .then(response => {
        response.json().then(resp => {
          this.senTechList = JSON.parse(JSON.stringify(resp));
          for (const p of this.senTechList) {
            this.senTechs.push({
              label: p.firstname + " " + p.lastname,
              value: p.id,
              team: p.team
            });
          }
          console.log(this.senTechs);
        });
      });
  }

  public clearSearch() {
    this.availableForemen = [];
  }

  public async getShiftTypeList() {
    await shifts
      .getShiftTypes(this.$store.getters.getToken, this.$store.getters.getHost)
      .then(response => {
        response.json().then((resp: any) => {
          let i = 0;
          while (i <= JSON.parse(JSON.stringify(resp)).length - 1) {
            this.types.push({
              value: JSON.parse(JSON.stringify(resp))[i].id,
              label:
                JSON.parse(JSON.stringify(resp))[i].literal +
                " (" +
                JSON.parse(JSON.stringify(resp))[i].time_start +
                " - " +
                JSON.parse(JSON.stringify(resp))[i].time_end +
                ")",
              start: JSON.parse(JSON.stringify(resp))[i].time_start,
              end: JSON.parse(JSON.stringify(resp))[i].time_end
            });
            i++;
          }
        });
      });
  }

  public async created() {
    await this.getPersonnelList();
    await this.getShiftTypeList();
    await this.getSenTechList();
    this.checkEdit();
    console.log(this.type);
  }

  public checkEdit() {
    this.row = this.$store.getters.getCurrentObject;
    if (this.row.id != undefined) {
      console.log(this.row);
      this.type = this.row.type;
      this.date = this.row.shift_date;
      this.foreman =
        this.row.foreman.firstname + " " + this.row.foreman.lastname;
      if (this.row.senTech != undefined) {
        this.senTech =
          this.row.senTech.firstname + " " + this.row.senTech.lastname;
      }

      for (const p of JSON.parse(this.row.personnel)) {
        console.log(p);
        if (!p.standby) {
          this.techs.push({
            id:
              this.personnelList.find(r => r.id == p.personnel_id).firstname +
              " " +
              this.personnelList.find(r => r.id == p.personnel_id).lastname,
            value: p.personnel_id,
            start:
              (new Date(p.date_started).getHours() < 10
                ? "0" + new Date(p.date_started).getHours()
                : new Date(p.date_started).getHours()) +
              ":" +
              (new Date(p.date_started).getMinutes() < 10
                ? "0" + new Date(p.date_started).getMinutes()
                : new Date(p.date_started)),
            end:
              (new Date(p.date_ended).getHours() < 10
                ? "0" + new Date(p.date_ended).getHours()
                : new Date(p.date_ended).getHours()) +
              ":" +
              (new Date(p.date_ended).getMinutes() < 10
                ? "0" + new Date(p.date_ended).getMinutes()
                : new Date(p.date_ended))
          });
        } else {
          this.standbyTechs.push({
            id:
              this.personnelList.find(r => r.id == p.personnel_id).firstname +
              " " +
              this.personnelList.find(r => r.id == p.personnel_id).lastname,
            value: p.personnel_id,
            start:
              (new Date(p.date_started).getHours() < 10
                ? "0" + new Date(p.date_started).getHours()
                : new Date(p.date_started).getHours()) +
              ":" +
              (new Date(p.date_started).getMinutes() < 10
                ? "0" + new Date(p.date_started).getMinutes()
                : new Date(p.date_started)),
            end:
              (new Date(p.date_ended).getHours() < 10
                ? "0" + new Date(p.date_ended).getHours()
                : new Date(p.date_ended).getHours()) +
              ":" +
              (new Date(p.date_ended).getMinutes() < 10
                ? "0" + new Date(p.date_ended).getMinutes()
                : new Date(p.date_ended))
          });
        }
      }
    }
  }
  public print() {
    console.log(this.techs);
    console.log(this.type);
  }
  public beforeDestroy() {
    this.$store.dispatch("updateCurrentObject", {});
  }
  public addToDB() {
    let techsToAdd = [];
    for (const tech of this.techs) {
      let t = JSON.parse(JSON.stringify(tech));
      let starthour = t.start.split(":")[0];
      let startminute = t.start.split(":")[1];
      let endhour = t.end.split(":")[0];
      let endminute = t.end.split(":")[1];
      t.start = new Date(
        new Date(this.date).setHours(starthour, startminute, 0, 0)
      );
      t.end = new Date(new Date(this.date).setHours(endhour, endminute, 0, 0));
      t.id = t.value;
      t.standby = false;
      techsToAdd.push(t);
    }
    for (const tech of this.standbyTechs) {
      let t = JSON.parse(JSON.stringify(tech));
      let starthour = t.start.split(":")[0];
      let startminute = t.start.split(":")[1];
      let endhour = t.end.split(":")[0];
      let endminute = t.end.split(":")[1];
      t.start = new Date(
        new Date(this.date).setHours(starthour, startminute, 0, 0)
      );
      t.end = new Date(new Date(this.date).setHours(endhour, endminute, 0, 0));
      t.id = t.value;
      t.standby = true;
      techsToAdd.push(t);
    }
    let shiftItem: any[] = [
      {
        shift_date: this.date,
        foreman: isNaN(this.foreman)
          ? this.personnelList.find(
              r =>
                r.firstname == this.foreman.split(" ")[0] &&
                r.lastname == this.foreman.split(" ")[1]
            ).id
          : this.foreman,
        type: this.type,
        senTech: isNaN(this.senTech)
          ? this.senTechList.find(
              r =>
                r.firstname == this.senTech.split(" ")[0] &&
                r.lastname == this.senTech.split(" ")[1]
            ).id
          : this.senTech
      },
      techsToAdd
    ];
    console.log(shiftItem);
    if (this.row.id != undefined) {
      shiftItem[0].id = this.row.id;
      shifts
        .editShift(
          this.$store.getters.getToken,
          shiftItem,
          this.$store.getters.getHost
        )
        .then(r => {
          if (r.status == 400) {
            this.$message.error(r.error);
          } else {
            this.$store.dispatch("updateCurrentObject", {});
            this.$store.dispatch("updateCurrentComponent", "ShiftList");
            this.$message.success("Shift Edited");
            this.$router.replace({
              name: "load"
            });
          }
        });
    } else {
      shifts
        .addShift(
          this.$store.getters.getToken,
          shiftItem,
          this.$store.getters.getHost
        )
        .then(r => {
          if (r.status == 400) {
            this.$message.error(r.error);
          } else {
            this.$store.dispatch("updateCurrentObject", {});
            this.$store.dispatch("updateCurrentComponent", "ShiftList");
            this.$message.success("Shift Added");
            this.$router.replace({
              name: "load"
            });
          }
        });
    }
  }
  public pushStandbyPersonnel() {
    this.standbyTechs.push({
      id:
        this.personnelList.find(r => r.id == this.selectedStandbyTech)
          .firstname +
        " " +
        this.personnelList.find(r => r.id == this.selectedStandbyTech).lastname,
      value: this.selectedStandbyTech,
      start: "08:00",
      end: "16:00"
    });
    this.selectedStandbyTech = "";
    this.availableForemen = [];
    this.availablePersonnel = [];
    console.log(this.standbyTechs);
  }
  public standbyTechUpdate(id: any, index: number) {
    if (id == "") {
      this.standbyTechs.splice(index, 1);
    }
    console.log(this.standbyTechs);
  }
  public endTimeStandbyChange(index: number) {
    if (this.standbyTechs[index].end.length === 2) {
      this.standbyTechs[index].end = this.standbyTechs[index].end + ":";
    }
  }
  public startTimeStandbyChange(index: number) {
    if (this.standbyTechs[index].start.length === 2) {
      this.standbyTechs[index].start = this.standbyTechs[index].start + ":";
    }
  }
}
